import React from "react";
import { NavBar } from "./NavBar";
import Logo from "../assets/simbol-Pillar.webp";

import QuoteImg from "../assets/QuoteImg.webp";

export function AdditionalProducts({ onOpenModal }) {
  return (
    <>
      <section className="aboutUs">
        <div className="productsVerticalText">
          <img src={Logo} alt="Pillar Hydraulics Logo" className="logoLarge" />
          <h6>Find out more about</h6>
          <h3>Featured Additional Products</h3>
        </div>
        <div className="productsContainer">
          <div className="verticalFlex">
            <h4>Accumulator Manifold Systems:</h4>
            <p className="bodyText">
              Custom design your own manifold system to meet site specific
              needs.
            </p>
          </div>
          <div className="verticalFlex">
            <h4>BOP (Blowout Preventor Accumulator System)</h4>
            <p className="bodyText">
              A critical safety component in oil and gas drilling that is
              specifically designed to store hydraulic energy for emergency
              services in case of power failure or well blowout.
            </p>
          </div>
        </div>
        <div className="productsFooter">
          <div className="verticalFlex">
            <p className="bodyText">Let us know if you have any questions.</p>
            <button className="yellowBtn" onClick={onOpenModal}>
              Contact Us
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
